import { stringify } from 'qs'
import axios from 'axios'
import { CMSApiResponseBody } from 'types/cms/request'
import { Language } from 'types/language'
import { CmsVideoTestimonial } from 'types/cms/collection-types'

const getVideoTestimonials = async (locale: Language): Promise<CmsVideoTestimonial[]> => {
  try {
    const query = stringify({ locale })

    const { data } = await axios.get<CMSApiResponseBody<CmsVideoTestimonial[]>>(`${process.env.CMS_API_URL}/video-testimonials?${query}`)

    return data.data || []
  } catch (_) {
    return []
  }
}

export default getVideoTestimonials
